import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { CostEstimateRowsCalculator } from "../services/costEstimateRowsService";
import articlesCalc, { TimeHelper } from "../services/articlesCalcService";

function Interval(props) {
    return props.column.get(props);
}

class OrderConfirmation extends Component {
    constructor(props) {
        super(props);
        const quantity = null;

        this.headings = [
            {
                get: props => {
                    return (
                        <React.Fragment>
                            <input
                                type="radio"
                                name="quantity"
                                value={props.multiplier}
                                id={"quantity" + props.multiplier}
                                checked={
                                    props.multiplier ==
                                    this.state.desiredQuantity
                                }
                                onChange={event =>
                                    this.handleQuantityChange(event)
                                }
                            />
                            <label htmlFor={"quantity" + props.multiplier}>
                                {props.multiplier}
                            </label>
                        </React.Fragment>
                    );
                },
                // get: multiplier => multiplier,
                heading: "Önskat antal",
                name: "quantity"
            },
            {
                get: props => {
                    return CostEstimateRowsCalculator.getTotalWeight(props);
                },
                heading: "Vikt i kg",
                name: "totalWeight"
            },
            {
                get: props => {
                    var price = Number(
                        CostEstimateRowsCalculator.getTotalUnitPrice(props)
                    );

                    return price.toSek();
                },
                heading: "Pris/st",
                name: "undefined"
            },
            {
                get: props => {
                    return Number(
                        CostEstimateRowsCalculator.getTotalPrice(props)
                    ).toSek();
                },
                heading: "Pris",
                name: "undefined"
            }
        ];

        if (CostEstimateRowsCalculator.getTotalDiscount(this.props) > 0) {
            this.headings = [
                ...this.headings,
                {
                    get: props => {
                        return (
                            CostEstimateRowsCalculator.getTotalDiscount(props) +
                            "%"
                        );
                    },
                    heading: "Rabatt",
                    name: "undefined"
                },
                {
                    get: props => {
                        var price = Number(
                            CostEstimateRowsCalculator.getTotalUnitPriceAfterDiscount(
                                props
                            )
                        );

                        return price.toSek();
                    },
                    heading: "Pris/st",
                    name: "undefined"
                }
            ];
        }

        this.headings = [
            ...this.headings,
            {
                get: props => {
                    return Number(
                        CostEstimateRowsCalculator.getTotalPriceAfterDiscount(
                            props
                        )
                    ).toSek();
                },
                heading: "Slutpris",
                name: "undefined"
            }
        ];

        this.state = {
            quantity
        };
    }

    updateCalculatedRows() {
        window.orderConfirmationSettings.calculatedRows = [];

        this.props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);
            const quantity = row.quantity;
            if (quantity == 0) return;

            const multiplier = Number.parseFloat(this.state.desiredQuantity);

            let recalculatedMultiplier = multiplier;
            let weightMultiplier = multiplier;
            let timeMultiplier = multiplier;
            let recalculatedQuantity = quantity * multiplier;

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    recalculatedMultiplier = Math.ceil(
                        multiplier / row.objectsPerRow
                    );

                    recalculatedQuantity = quantity * recalculatedMultiplier;
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    recalculatedMultiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;

                    const sheetSizeM2 = (row.width * row.height) / 1000000;
                    const maxObjectsPerSheet = row.objectsPerRow;
                    const sheetsNeeded = Math.ceil(
                        multiplier / maxObjectsPerSheet
                    );

                    timeMultiplier = sheetsNeeded;
                    recalculatedQuantity = sheetsNeeded * sheetSizeM2;
                } else if (row.infoboard_id == 6) {
                    timeMultiplier = 1;
                }

                if (row.infoboard_id != 2) {
                    weightMultiplier = Math.ceil(multiplier / row.objectsPerRow);
                }
            }

            const calculatedRow = {
                article_number: row.article_number,
                name: row.name,
                quantity: row.is_single
                    ? quantity
                    : Number.parseFloat(recalculatedQuantity.toFixed(4)),
                unit: row.unit,
                discountPercent: calc.getDiscount().toFixed(2),
                totalPriceBeforeDiscount: calc
                    .getPrice(row.is_single ? 1 : recalculatedMultiplier)
                    .toFixed(2),
                totalPriceAfterDiscount: calc
                    .getPriceAfterDiscount(
                        row.is_single ? 1 : recalculatedMultiplier
                    )
                    .toFixed(2),
                time:
                    calc.getStartSeconds() +
                    calc.getProductionSeconds() *
                    (row.is_single ? 1 : timeMultiplier),
                weight:
                    calc.get("weight") == "" || isNaN(calc.get("weight"))
                        ? 0
                        : Number.parseFloat(calc.get("weight")) *
                        (row.is_single ? 1 : weightMultiplier),
                infoboarddata: row.infoboarddata
            };

            calculatedRow.unitPriceBeforeDiscount = (
                calculatedRow.totalPriceBeforeDiscount / calculatedRow.quantity
            ).toFixed(2);

            window.orderConfirmationSettings.calculatedRows.push(calculatedRow);

            row.children.forEach(childRow => {
                const calc = new articlesCalc();
                calc.setData(childRow);
                let quantity = childRow.quantity;
                if (quantity == 0) return;

                var multiplier = Number.parseFloat(this.state.desiredQuantity);

                if (childRow.objectsPerRow != undefined) {
                    multiplier = Math.ceil(multiplier / childRow.objectsPerRow);
                }

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                if (childRow.is_single) multiplier = 1;

                quantity *= multiplier;

                const calculatedRow = {
                    article_number: childRow.article_number,
                    name: childRow.name,
                    quantity: quantity,
                    unit: childRow.unit,
                    discountPercent: calc.getDiscount().toFixed(2),
                    totalPriceBeforeDiscount: calc
                        .getPrice(multiplier)
                        .toFixed(2),
                    totalPriceAfterDiscount: calc
                        .getPriceAfterDiscount(multiplier)
                        .toFixed(2),
                    time:
                        calc.getStartSeconds() +
                        calc.getProductionSeconds() * multiplier,

                    weight:
                        calc.get("weight") == "" || isNaN(calc.get("weight"))
                            ? 0
                            : Number.parseFloat(calc.get("weight")) * multiplier

                };

                calculatedRow.unitPriceBeforeDiscount = (
                    calculatedRow.totalPriceBeforeDiscount /
                    calculatedRow.quantity
                ).toFixed(2);

                window.orderConfirmationSettings.calculatedRows.push(
                    calculatedRow
                );
            });
        });

    }

    handleQuantityChange(event) {
        this.setState({ desiredQuantity: event.target.value }, () => {
            this.updateCalculatedRows();
        });
    }

    componentDidMount() {
        this.setState({ desiredQuantity: this.props.desiredQuantity }, () => {
            this.updateCalculatedRows();
        });
    }

    render() {
        const { quantities } = this.props;
        const { desiredQuantity } = this.props;
        let { ...allProps } = this.props;
        allProps.multiplier = this.state.desiredQuantity;

        return (
            <Fragment>
                <table className="table table-itemList table-orderConfirmationList">
                    <thead>
                        <tr>
                            {this.headings.map((column, index) => (
                                <th key={index} className="text-right">
                                    {column.heading}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {quantities.map((multiplier, rowIndex) => {
                            const rows = [...this.props.rows];
                            Object.keys(rows).forEach(key => {
                                const row = { ...rows[key] };
                                row["quantity"] = Number.parseFloat(row["quantity"]);
                                rows[key] = row;
                            });
                            const data = {
                                multiplier,
                                rows
                            };

                            return (
                                <tr key={rowIndex}>
                                    {this.headings.map(
                                        (column, columnIndex) => {
                                            return (
                                                <td
                                                    key={columnIndex}
                                                    className="text-right"
                                                >
                                                    <Interval
                                                        column={column}
                                                        columnIndex={
                                                            columnIndex
                                                        }
                                                        data={data}
                                                        multiplier={multiplier}
                                                        desiredQuantity={
                                                            desiredQuantity
                                                        }
                                                        rowIndex={rowIndex}
                                                        rows={rows}
                                                    />
                                                </td>
                                            );
                                        }
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <input
                    type="hidden"
                    value={
                        this.state.desiredQuantity
                            ? Number(
                                CostEstimateRowsCalculator.getTotalPriceAfterDiscount(
                                    allProps
                                )
                            )
                            : 0
                    }
                    name="value_amount"
                    readOnly
                />
                <input
                    type="hidden"
                    value={
                        this.state.desiredQuantity
                            ? Number(
                                CostEstimateRowsCalculator.getTotalMarginSek(
                                    allProps
                                )
                            )
                            : 0
                    }
                    name="margin_amount"
                    readOnly
                />
            </Fragment>
        );
    }
}

if (window.orderConfirmationSettings) {
    const t = window.orderConfirmationSettings;
    ReactDOM.render(
        <OrderConfirmation
            contact={t.data.contact}
            costEstimateId={t.data.costEstimateId}
            deliveryDays={t.data.deliveryDays}
            hash={t.data.hash}
            name={t.data.name}
            quantities={t.data.quantities}
            desiredQuantity={t.data.desiredQuantity}
            customer={t.data.customer}
            rows={t.data.rows}
            quantity={t.data.quantity}
        />,
        t.settings.target
    );
}
